export default "__VITE_ASSET__490702f9__"